import React from 'react';
import JsonCodeEditor from '../../../shared/components/JsonCodeEditor';

interface EventPatternEditorProps {
  value: Record<string, unknown>;
  onChange: (pattern: Record<string, unknown>) => void;
  onValidityChange?: (valid: boolean, error?: string) => void;
  error?: string;
  readOnly?: boolean;
}

const DEFAULT_PATTERN = {
  source: ['aws.ec2'],
  'detail-type': ['EC2 Instance State-change Notification'],
  detail: {
    state: ['running', 'stopped'],
  },
};

const EventPatternEditor: React.FC<EventPatternEditorProps> = ({
  value,
  onChange,
  onValidityChange,
  error,
  readOnly,
}) => (
  <JsonCodeEditor
    label="Event pattern"
    required
    readOnly={readOnly}
    value={value}
    onChange={onChange}
    onValidityChange={onValidityChange}
    externalError={error}
    placeholder={DEFAULT_PATTERN}
    minHeight={150}
  />
);

export default EventPatternEditor;
